import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { X, Disc3 } from "lucide-react";

import session from "../Utils/session";
import config from "../Utils/config";

/**
 * Slim mobile-only top bar (lg:hidden). Desktop navigation lives in the
 * left vertical Rail. ~56px tall.
 */
function Header({ onTogglePlaylist, playlistVisible }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    onTogglePlaylist(true);
    navigate(path);
  };

  return (
    <header className="lg:hidden fixed top-0 left-0 right-0 bg-primary border-b border-neutral-800 z-50">
      <div className="flex items-center justify-between px-3 h-14">
        {/* Left — avatar */}
        <button
          onClick={() => handleNavigation("/app/me")}
          className="flex items-center hover:opacity-80 transition-opacity"
          aria-label="My Profile"
        >
          <img
            src={`${config.serverUrl}/users/profile/${session.getUsername()}/avatar`}
            className="w-8 h-8 border border-neutral-700 rounded-full object-cover"
            alt="Profile"
          />
        </button>

        {/* Center — wordmark */}
        <button
          onClick={() => handleNavigation("/app")}
          className="text-text text-sm font-bold uppercase tracking-[0.3em] hover:text-text-muted transition-colors"
        >
          Muzio
        </button>

        {/* Right — DJ + drawer toggle */}
        <div className="flex items-center gap-1">
          <button
            onClick={() => handleNavigation("/app/dj")}
            className={`flex items-center justify-center w-8 h-8 hover:opacity-80 transition-opacity ${location.pathname.startsWith("/app/dj") ? "text-pink-400" : "text-text-muted"}`}
            aria-label="DJ mode"
            title="DJ mode"
          >
            <Disc3 className="w-5 h-5" />
          </button>
          <button
            onClick={() => {
              if (playlistVisible) {
                onTogglePlaylist(false);
              } else {
                handleNavigation("/app");
              }
            }}
            className="p-1.5 text-text hover:bg-secondary rounded-md transition-colors"
            aria-label={playlistVisible ? "Close Panel" : "Open Home"}
          >
            {playlistVisible ? (
              <X className="w-5 h-5" />
            ) : (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
